<div class="wrap">
  <div class="left" (click)="openDetails()">
    <div
      class="image"
      [appBackgroundImage]="product.photos[0] | productImage | async"
      [class.no-image]="product.photos.length < 1"
    ></div>
    <div class="details">
      <div class="header">
        {{ "@components.scannedProductToast.header" | translate }}:
      </div>
      <div class="product-name">{{ product.name | ellipsisSlice : 50 }}</div>
      <div class="price">
        <app-price-label
          [value]="product | getRelevantProductPrice | appCurrency | async"
          [isCompact]="true"
          [noIcon]="true"
          [secondaryCurrencyAlight]="'start'"
        ></app-price-label>
      </div>
      <div class="hint">
        {{ "@components.scannedProductToast.hint" | translate }}
      </div>
    </div>
  </div>
  <div class="right">
    <div class="action-btn" (click)="dismissAsToast.next(true)">
      {{ "@components.scannedProductToast.cta" | translate }}
    </div>
  </div>
</div>
